import Actions from '../actions/google';

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
    case Actions.SET_GOOGLE_PLACE_ID:
        return { ...state, placeId: action.placeId };
    default:
        return state;
    }
};
